export default "<app-main-nav [ContentType]=\"1\">\n  <router-outlet></router-outlet>\n</app-main-nav>\n"